import { render, staticRenderFns } from "./HubForm.vue?vue&type=template&id=004a3bea&scoped=true"
import script from "./HubForm.vue?vue&type=script&lang=js"
export * from "./HubForm.vue?vue&type=script&lang=js"
import style0 from "./HubForm.vue?vue&type=style&index=0&id=004a3bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a3bea",
  null
  
)

export default component.exports